<p-table [value]="standardTitles?.content"
         [paginator]="true"
         [lazy]="true"
         [loading]="!standardTitles?.content"
         paginatorPosition="bottom"
         (onLazyLoad)="onPageChange($event)"
         [totalRecords]="standardTitles?.totalElements"
         [rows]="pageSize"
         class="admin-table">

  <ng-template pTemplate="emptymessage" let-columns>
    <div>{{ 'WS_DIRECTORY.TABLE_EMPTY' | translate }}</div>
  </ng-template>

  <ng-template pTemplate="caption">
    <div class="ui-g">
      <div class="ui-g-3">
        <input pInputText
               [(ngModel)]="filter.name"
               (keyup)="search()"
               [placeholder]=" 'WS_DIRECTORY.SEARCH.PLACEHOLDER' | translate">
      </div>
      <div class="ui-g-9">
        <button pButton class="ui-button-success fright"
                label="{{ 'WS_DIRECTORY.STANDARD_TITLE.ADD' | translate }}"
                (click)="create()"></button>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th>{{ 'WS_DIRECTORY.STANDARD_TITLE.RANK' | translate }}</th>
      <th width="600">{{ 'WS_DIRECTORY.STANDARD_TITLE.TITLE' | translate }}</th>
      <th></th>
    </tr>
  </ng-template>

  <ng-template let-title pTemplate="body">
    <tr>
      <td><span>{{ title.order }}</span></td>
      <td><span>{{ getTranslatedName(title.names) }}</span></td>
      <td class="action-column">
        <i class="fa fa-trash delete-appointment fright"
           (click)="confirmDelete(title)"
           pTooltip="{{ 'WS_DIRECTORY.STANDARD_TITLE.REMOVE_TOOLTIP' | translate }}"></i>
        <i class="fa fa-pen edit-appointment fright"
           (click)="modify(title)"
           pTooltip="{{ 'WS_DIRECTORY.STANDARD_TITLE.MODIFY_TOOLTIP' | translate }}"></i>
      </td>
  </ng-template>
</p-table>

<wsd-add-standard-title (onSave)="onSave($event)"></wsd-add-standard-title>

<wsd-global-messages [life]="4000"></wsd-global-messages>
